module.exports = __webpack_public_path__ + "static/traiteur.830abb9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/traiteur.png
// module id = 565
// module chunks = 220905330635604